<template>
  <qx-card title="地图信息">
    <CarDetailDialog ref="carDetailDialog" />
    <el-button
      v-for="item in navList"
      :key="item.eventCode"
      @click="setActive(item)"
      :type="activeNav === item ? 'primary' : ''"
      class="navBtn"
    >
      {{item.eventName}}（{{item.vehicleCount}}）
    </el-button>
    <section class="mapContent posire">
      <baidu-map
        class="map"
        :scroll-wheel-zoom="true"
        :center="center"
        :zoom="zoom"
        @ready="renderMap"
      >
        <bm-view class="map" />
        <!-- 左上角logo -->
        <bm-control>
          <section class="logoBox">
            <span class="primary item">
              <img src="~images/operate/noOrder.png" />
              无单
            </span>
            <span class="primary item">
              <img src="~images/operate/order.png" />
              有单
            </span>
            <span class="primary item">
              <img src="~images/operate/noOrderCar.png" />
              无单挂车
            </span>
            <span class="primary item">
              <img src="~images/operate/orderCar.png" />
              有单挂车
            </span>
          </section>
        </bm-control>
        <!-- 左上角logo end -->
        <!-- 右上角车列表 -->
        <bm-control anchor="BMAP_ANCHOR_TOP_RIGHT">
          <section class="carListBox" @wheel.stop="() => {}" v-loading="carListLoading">
            <p class="carListTitle">车辆列表（共
              <span class="primary">{{total}}</span>
              辆车）
            </p>
            <section class="carList">
              <p class="noCar" v-show="carList.length === 0">暂无数据</p>
              <section
                class="item cur"
                :class="{activeCarNav: activeCar === item}"
                v-for="(item, index) in carList"
                :key="index"
                @click="setFocusCar(item)"
              >
                <span class="primary">{{item.plateNumber}}</span>
                （订单：{{item.orderId}}）
              </section>
            </section>
            <section class="listBtnBox" v-show="carList.length !== 0">
              <el-pagination
                :small="true"
                @current-change="(page) => {this.carCurrentPage = page;handleCurrentChange(page)}"
                :current-page="carCurrentPage"
                :total="total"
                :page-size="count"
                layout="prev, pager, next">
              </el-pagination>
            </section>
            <section class="listBtnBox exportBtnBox" v-show="carList.length !== 0">
              <qx-permpisions permpisions="">
                <ExportBtn :len="1"
                  queryUrl='vehicleMonitorBO.ajax?cmd=getVehicleList'
                  :params="{
                    eventCode: activeNav.eventCode,
                    agingType: activeNav.eventCode,
                    ...searchBoxData,
                  }"
                  :bizName="activeNav.eventName + '车辆列表数据导出'"
                  bizCode="exp100048"
                  excelKeys="plateNumber,eventName,orderId"
                  excelLables="车牌号,业务类型,订单号"
                  type="sync"
                />
              </qx-permpisions>
            </section>
          </section>
        </bm-control>
        <!-- 右上角车列表 end -->
        <bm-overlay
            ref="carListOverlay"
          v-for="(item, index) in carList"
          :key="index"
          :class="{activeCar: activeCar === item}"
          pane="labelPane"
          class="posiab"
          @draw="({el, BMap, map}) => draw({el, BMap, map, item})"
        >
          <span class="cur" @click="showCarDetailDialog(item)">
            <img v-if="!item.orderId && item.vehicleClass !== 6" src="~images/operate/noOrder.png" />
            <img v-if="item.orderId && item.vehicleClass !== 6" src="~images/operate/order.png" />
            <img v-if="!item.orderId && item.vehicleClass === 6 " src="~images/operate/noOrderCar.png" />
            <img v-if="item.orderId && item.vehicleClass === 6" src="~images/operate/orderCar.png" />
          </span>
        </bm-overlay>
      </baidu-map>
    </section>
  </qx-card>
</template>

<script>
import {
  trackScreenNav,
  invoiceApplyCarList,
} from 'api/operate';
import CarDetailDialog from './carDetailDialog';
import ExportBtn from 'components/exportBtn';
export default {
  components: {
    CarDetailDialog,
    ExportBtn,
  },
  data () {
    return {
      active: false,
      searchBoxData: {},
      activeNav: {},
      navList: [
        // {
        //   eventCode: '',
        //   eventName: '',
        //   vehicleCount: '',
        // },
      ],
      carListLoading: false,
      activeCar: {},
      carList: [],
      carCurrentPage: 1,
      count: 10,
      BMap: null,
      map: null,
      center: {lng: 0, lat: 0},
      zoom: 3,
      pointDescVisible: false,
      markerPoint: null,
      markerPointAddress: '',
      total: null,
    };
  },
  watch: {
    carList: {
      deep: true,
      handler () {
        if (this.carList.length > 0) {
          this.$refs.carListOverlay.length > 0 ? this.$refs.carListOverlay[0].reload() : '';
        }
      },
    },
  },
  computed: {
    // carShowList () {
    //   return this.carList.slice(
    //     (this.carCurrentPage - 1) * 10,
    //     this.carCurrentPage * 10
    //   );
    // },
  },
  methods: {
    handleCurrentChange (page) {
      if (this.carCurrentPage) {
        this.carCurrentPage = page;
      }
      this.getCarData();
    },
    async saveSearchBoxData (searchBoxData) {
      this.searchBoxData = searchBoxData;
      this.getNavData();
    },
    async getNavData () { // 获取导航btn数据
      this.navList = await trackScreenNav(this.searchBoxData);
      this.setActive(this.navList[0]);
    },
    async getCarData () { // 获取车辆数据
      this.carListLoading = true;
      const res = await invoiceApplyCarList({
        ...this.searchBoxData,
        eventCode: this.activeNav.eventCode,
        agingType: this.activeNav.eventCode,
        agingTypeName: this.activeNav.eventName,
        page: this.carCurrentPage,
        rows: 10,
      });
      this.carList = [];
      this.total = res.totalNum;
      res.items ? this.carList = res.items : '';
      this.carListLoading = false;
      if (this.carList[0]) {
        this.setFocusCar(this.carList[0]);
      }
    },
    setActive (item) { // 设置nav选中
      this.carCurrentPage = 1;
      this.activeNav = item;
      this.getCarData();
    },
    renderMap ({BMap, map}) { // 地图渲染
      this.BMap = BMap;
      this.map = map;
      this.markerPoint = this.center;
      this.center.lng = 116.404;
      this.center.lat = 39.915;
      this.zoom = 15;
    },
    setFocusCar (item) { // 车辆focus
      this.activeCar = item;
      var point = new this.BMap.Point(item.currLongitude, item.currLatitude);
      this.map.panTo(point);
    },
    draw ({el, BMap, map, item}) {
      const pixel = map.pointToOverlayPixel(new BMap.Point(item.currLongitude, item.currLatitude));
      el.style.left = pixel.x - 60 + 'px';
      el.style.top = pixel.y - 20 + 'px';
    },
    showCarDetailDialog (item) {
      const geoc = new this.BMap.Geocoder();
      const pt = new this.BMap.Point(item.currLongitude, item.currLatitude);
      geoc.getLocation(pt, (rs) => {
        const addComp = rs.addressComponents;
        const markerPointAddress = addComp.province + addComp.city + addComp.district + addComp.street + addComp.streetNumber;
        this.$refs.carDetailDialog.show({
          ...this.activeNav,
          ...item,
          markerPointAddress,
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.navBtn{
  margin-bottom: 16px;
}
.mapContent{
  padding-bottom: 32px;
  .map {
    width: 100%;
    height: 500px;
  }
}
.logoBox{
  background: rgba(255, 255, 255, .8);
  border-radius: 8px;
  padding: 8px 16px;
  margin: 24px;
  .item{
    margin: 0 8px;
  }
}
.carListBox{
  background: rgba(255, 255, 255, .8);
  border-radius: 8px;
  margin: 24px;
  .carListTitle{
    text-align: center;
    height: 36px;
    line-height: 36px;
    padding: 8px 16px;
  }
  .carList{
    max-height: 300px;
    overflow-y: auto;
    .activeCarNav{
      background: rgba(0, 136, 255, .3);
    }
  }
  .noCar{
    text-align: center;
    height: 36px;
    line-height: 36px;
  }
  .item{
    border-bottom: 1px solid #e0e0e0;
    height: 36px;
    line-height: 36px;
    padding: 8px 16px;
  }
  .item:hover{
    background: #e0e0e0;
  }
  .activeCarNav:hover{
    background: rgba(0, 136, 255, .3);
  }
}
.activeCar {
  z-index: 10;
}
.listBtnBox{
  padding-top: 8px;
  text-align: center;
}
.exportBtnBox{
  padding-bottom: 16px;
}
</style>
